import {Component, EventEmitter, Output, Input, ElementRef} from '@angular/core'
@Component({
  selector:'app-note',
  templateUrl:'./note.component.html',
  styleUrls:['./note.component.scss'],
})

export class NoteComponent 
{
  @Output() dismiss = new EventEmitter();
  @Output() blur = new EventEmitter();
  @Input() firstElement: any;
  @Input() roleForFacility: boolean = true;
  @Input() isAccessRead: boolean = true;
  constructor(private el:ElementRef) {
  }
  onDismiss(event: any){
    if(!this.isAccessRead && !this.roleForFacility){
      this.dismiss.emit(event);
    }
  }
  
  onFocusOut(event: any){
    this.blur.emit(event)
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text/plain') || '';
    const cleanedText = pastedText.replace(/(\r\n|\n|\r)/gm, '');
    document.execCommand('insertText', false, cleanedText);
  }

}
